import React from "react";

const DynamicNDA = ({ vendorData }) => {
  if (!vendorData) return <div>Fill Onboarding Form</div>;

  // sensible fallbacks if vendorData uses different keys
  const partyAName =
    vendorData.companyName || vendorData.modelNo || vendorData.name || "____________________________";
  const partyAAddress =
    vendorData.address || vendorData.registeredOffice || "__________________________________";
  const partyASignName = vendorData.signatoryName || vendorData.name || "";

  // Use current day and month but keep year as 2025 per the new template
  const now = new Date();
  const day = now.getDate();
  const month = now.toLocaleString("en-US", { month: "long" });
  const year = 2025;

  return (
    <div>
      <p><strong>NON-DISCLOSURE AGREEMENT (NDA)</strong></p>

      <p>
        This Non-Disclosure Agreement (“Agreement”) is made and entered into on this <strong>{day}</strong> day of <strong>{month}</strong>, <strong>{year}</strong>, by and between:
      </p>

      <p><strong>Party A:</strong></p>
      <p>
        {partyAName}, a company registered under the laws of India, having its registered office at {partyAAddress} (hereinafter referred to as “Party A”, which expression shall, unless repugnant to the context or meaning thereof, mean and include its successors, affiliates, administrators, and permitted assigns),
      </p>

      <p><strong>AND</strong></p>

      <p><strong>Party B:</strong></p>
      <p>
        SPH AVIATION PRIVATE LIMITED, CIN: U62100HR2022PTC105328, a company incorporated under the Companies Act, 1956, having its registered office at Plot 251 Udyog Vihar, Phase IV, Sector 18, Gurugram, Haryana, 122015 (hereinafter referred to as “SPH Aviation” or “Party B”, which expression shall, unless repugnant to the context or meaning thereof, mean and include its successors, affiliates, administrators, and permitted assigns).
      </p>

      <p>Party A and Party B are hereinafter collectively referred to as the “Parties” and individually as a “Party”.</p>

      <p><strong>1. Purpose</strong></p>
      <p>
        The Parties intend to explore potential business opportunities and collaborations, which may include but are not limited to, joint projects, product development, training programs, service arrangements, or any other form of cooperation (“Proposed Relationship”). In this context, the Parties may disclose to each other certain confidential and proprietary information. This Agreement sets forth the terms and conditions governing the disclosure and protection of such information.
      </p>

      <p><strong>2. Definition of Confidential Information</strong></p>
      <p>
        For the purposes of this Agreement, “Confidential Information” shall mean any non-public, proprietary, technical, business, financial, strategic, or operational information disclosed by one Party (“Disclosing Party”) to the other Party (“Receiving Party”), whether disclosed orally, in writing, electronically, or in any other form, including but not limited to:
      </p>
      <p>(a) Business strategies, plans, and operations;</p>
      <p>(b) Technical data, designs, specifications, know-how, software, and intellectual property;</p>
      <p>(c) Customer, supplier, and partner details;</p>
      <p>(d) Financial information, pricing, contracts, and agreements;</p>
      <p>(e) Any information designated as confidential, or that should reasonably be understood as confidential given the nature of the information and circumstances of disclosure.</p>

      <p><strong>3. Exclusions from Confidential Information</strong></p>
      <p>
        Confidential Information shall not include information that:
      </p>
      <p>(a) Is or becomes publicly available without breach of this Agreement;</p>
      <p>(b) Is lawfully received from a third party without restriction on disclosure;</p>
      <p>(c) Was in the Receiving Party’s possession prior to disclosure by the Disclosing Party;</p>
      <p>(d) Is independently developed by the Receiving Party without reference to the Disclosing Party’s Confidential Information;</p>
      <p>(e) Is required to be disclosed under applicable law, regulation, or court order, provided that the Receiving Party gives prompt written notice to the Disclosing Party and cooperates in seeking protective measures.</p>

      <p><strong>4. Obligations of the Receiving Party</strong></p>
      <p>(a) Non-Disclosure: The Receiving Party shall not disclose the Confidential Information to any third party without the prior written consent of the Disclosing Party, except as permitted under this Agreement.</p>
      <p>(b) Non-Use: The Receiving Party shall use the Confidential Information solely for the Purpose stated in Clause 1.</p>
      <p>(c) Protection: The Receiving Party shall exercise the same degree of care to protect the Confidential Information as it uses to protect its own confidential information, but in no event less than reasonable care.</p>
      <p>(d) Return/Destruction: Upon termination of this Agreement or upon request, the Receiving Party shall promptly return or securely destroy all materials containing Confidential Information.</p>

      <p><strong>5. Permitted Disclosures</strong></p>
      <p>
        The Receiving Party may disclose Confidential Information to its employees, consultants, contractors, or advisors on a need-to-know basis, provided that such individuals are bound by confidentiality obligations no less stringent than those in this Agreement.
      </p>

      <p><strong>6. Duration of Confidentiality Obligations</strong></p>
      <p>(a) The confidentiality obligations shall remain in effect for the duration of the Proposed Relationship and for a period of three (3) years after its termination.</p>
      <p>(b) Trade secrets shall remain protected for so long as they continue to constitute trade secrets under applicable law.</p>

      <p><strong>7. Intellectual Property</strong></p>
      <p>(a) All intellectual property and proprietary rights of each Party shall remain the sole property of that Party.</p>
      <p>(b) No license, assignment, or transfer of rights is implied by disclosure of Confidential Information under this Agreement.</p>
      <p>(c) Any jointly developed intellectual property shall be subject to a separate written agreement.</p>

      <p><strong>8. No Obligation to Proceed</strong></p>
      <p>Nothing in this Agreement obligates either Party to enter into any definitive agreement, transaction, or further business relationship.</p>

      <p><strong>9. Remedies</strong></p>
      <p>
        In the event of a breach of this Agreement, the Disclosing Party shall be entitled to seek injunctive relief, specific performance, and/or damages, in addition to any other remedies available under law.
      </p>

      <p><strong>10. Governing Law & Jurisdiction</strong></p>
      <p>
        This Agreement shall be governed by and construed in accordance with the laws of India. The courts of New Delhi shall have exclusive jurisdiction over any disputes arising under or in connection with this Agreement.
      </p>

      <p><strong>11. Dispute Resolution</strong></p>
      <p>
        The Parties shall first attempt to resolve any dispute through good faith negotiations. If unresolved within 30 days, the dispute shall be referred to arbitration under the Arbitration and Conciliation Act, 1996, with a sole arbitrator mutually appointed. The seat of arbitration shall be New Delhi, and the proceedings shall be conducted in English.
      </p>

      <p><strong>12. Term and Termination</strong></p>
      <p>(a) This Agreement shall commence on the date first written above and remain in effect until terminated by either Party with 30 days’ prior written notice.</p>
      <p>(b) Termination shall not affect the obligations of confidentiality with respect to information disclosed prior to termination.</p>

      <p><strong>13. Miscellaneous</strong></p>
      <p>(a) Entire Agreement: This Agreement constitutes the entire understanding between the Parties with respect to the subject matter herein.</p>
      <p>(b) Amendments: Any modification must be in writing and signed by both Parties.</p>
      <p>(c) No Waiver: Failure to enforce any provision shall not constitute a waiver.</p>
      <p>(d) Counterparts: This Agreement may be executed in counterparts (including electronic signatures), each of which shall be deemed an original.</p>

      <p><strong>14. Execution</strong></p>
      <p>IN WITNESS WHEREOF, the Parties hereto have executed this Non-Disclosure Agreement on the date first written above.</p>

      <p><strong>For Party A</strong></p>
      <p>Company: {partyAName}</p>
      <p>Name: {partyASignName || "__________________________________"}</p>
      <p>Designation: ____________________________</p>
      <p>Date: {`${day} ${month} ${year}`}</p>

      <br />

      <p><strong>For SPH AVIATION PRIVATE LIMITED</strong></p>
      <p>Name: __________________________________</p>
      <p>Designation: ____________________________</p>
      <p>Date: {`${day} ${month} ${year}`}</p>
    </div>
  );
};

export default DynamicNDA;
